

<template>
  <OpDialog
    :title="title || $t('ifttt.open')"
    :visible="visible"
    :is-show-btn="false"
    @onClose="onClose"
  >
    <div class="type-select">
      <div
        class="select-button"
        :class="{isActive: activeTab === 0}"
        @click="() => changeTab(0)"
      >
        {{ $t('sync.areaname') }}
      </div>
      <div
        class="select-button"
        :class="{isActive: activeTab === 1}"
        @click="() => changeTab(1)"
      >
        {{ $t('breadcrumb.device') }}
      </div>
    </div>
    <div>
      <div
        v-if="activeTab === 0"
        class="area-select"
      >
        <select-area
          :checkedarea="selectArea"
          class="limit_set"
          :areaid="gpNo"
          :area-self="false"
          :only-select-one="true"
          :filter-gp-no="true"
          @getarealist="setAreaList"
        />
        <div
          class="nextStep"
          @click="onAreaOk"
        >
          {{ $t('limite.finsh') }}
        </div>
      </div>
      
      <OpDeviceChoose
        v-if="activeTab === 1"
        :is_group="true"
        :areaid="gpNo"
        :area-tree-type="1"
        :execute-type="2"
        :displaynoarea="true"
        :triggledevice="true"
        :is-ifttt="true"
        :checkeddata="checkeddata"
        :required-message-type="requiredMessageType"
        @confirm="deviceValueChange"
      />
    </div>
  </OpDialog>
</template>
<script>
import OpDialog from '@/components/common/OpDialog';
import selectArea from '@/components/common/selectArea.vue';
import { FindTriggerAbility, FindDevice } from '@/axios/IDevice.js';

export default {
  components: { 
    OpDialog,
    selectArea,
    // OpDeviceChoose
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    gpNo: {
      type: Number,
      default: -1
    },
    title: {
      type: String,
      default: ''
    },
    requiredMessageType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeTab: 0,
      checkeddata: [],
      selectArea: [], // 已选的区域-数据
    }
  },

  watch: {
    requiredMessageType(vvv) {
      console.log('vvvv 2', vvv);
      
    },

    gpNo(val) {
      console.log('gpNo22', val);
    }
  },

  mounted() {
    console.log('gpNo11', this.gpNo);
    
  },

  created() {
  },
  methods: {
    changeTab(activeTab) {
      this.activeTab = activeTab;
    },
    onAreaOk() {
      this.$emit('onOk', {
        type: 'area',
        selectArea: this.selectArea[0]
      });
    },
    setAreaList (val) {
      this.selectArea = val
    },
    onClose() {
      this.$emit('onClose');
    },
    deviceValueChange(device) {
      this.checkeddata = device;
      
      this.$emit('onOk', {
        type: 'device',
        selectDevice: device[0]
      });

      // this.$emit('onOk', device);
    }
  }
}
</script>

<style lang="scss" scoped>
.area-select {
  .limit_left.limit_set {
    margin-top: 12px;
  }

  .nextStep {
    width: 76px;
    height: 31px;
    margin: 10px auto 20px;
    text-align: center;
    line-height: 31px;
    background-color: #0046aa;
    border-radius: 3px;
    border: solid 1px #0046aa;
    color: #fff;
    cursor: pointer;
  }
}
.type-select {
  display: flex;
  justify-content: center;
  .select-button {
    width: 175px;
    height: 35px;
    margin-bottom: 20px;
    text-align: center;
    line-height: 35px;
    border: 2px solid #0046AA;
    cursor: pointer;
    color: #0046AA;

    &.isActive {
      background-color: #0046AA;
      color: #fff;
    }
  }
}
</style>
